import { createSingleAction } from 'store/utils';

export const SET_COST_CENTERS_FILTER = 'settings/CostCenters/SET_COST_CENTERS_FILTER';
export const setCostCenterFilter = createSingleAction<string, typeof SET_COST_CENTERS_FILTER>(
    SET_COST_CENTERS_FILTER,
);
